import type { Theme } from "@mui/material/styles";
import * as Highcharts from "highcharts/highstock";

/**
 * Configure Highcharts global options to use the branded theme.
 * Graph colors are already set by BrandingProvider via Highcharts.setOptions().
 * This function applies typography from the MUI theme.
 */
export function configureHighchartsDefaults(theme: Theme): void {
  const fontFamily = theme.typography.fontFamily ?? "inherit";

  Highcharts.setOptions({
    chart: {
      style: { fontFamily },
    },
    title: {
      style: { fontFamily, fontWeight: "700" },
    },
    subtitle: {
      style: { fontFamily, fontWeight: "300" },
    },
    xAxis: {
      labels: { style: { fontFamily, fontWeight: "300" } },
      title: { style: { fontFamily, fontWeight: "500" } },
    },
    yAxis: {
      labels: { style: { fontFamily, fontWeight: "300" } },
      title: { style: { fontFamily, fontWeight: "500" } },
    },
    legend: {
      itemStyle: { fontFamily, fontWeight: "300" },
    },
    tooltip: {
      style: { fontFamily, fontWeight: "300" },
    },
  });
}
